import { useTranslation } from 'react-i18next'

import ImageNext from '@/components/ImageNext'

import { ASSET_PATHS } from '@/services/paths'

import * as S from './styles'

interface LoadingProps {
  className?: string
}

export default function Loading({ className }: LoadingProps) {
  const { t } = useTranslation()

  return (
    <S.LoadingCSS id="Loading" className={className && className}>
      <ImageNext
        src={ASSET_PATHS.animation_load}
        alt={t('alts.load')}
        width={50}
        height={50}
        style={{
          width: '50px',
          height: '50px',
          minWidth: '50px',
          minHeight: '50px',
          maxWidth: '50px',
          maxHeight: '50px',
          objectFit: 'contain'
        }}
      />
    </S.LoadingCSS>
  )
}
